import { RuotaMark } from "./RuotaMark";

const LINES = [
  "Follow what moves you.",
  "Go somewhere that changes you.",
  "See the world differently.",
  "Where will your journey take you?",
  "The world is waiting. Keep moving.",
];

export const Marquee = () => (
  <section
    aria-hidden="true"
    data-testid="brand-marquee"
    className="overflow-hidden border-y border-[rgba(22,138,145,0.15)] bg-[#EBE2D0] py-6"
  >
    <div className="animate-marquee flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {LINES.map((line) => (
            <span key={`${copy}-${line}`} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-display text-2xl italic text-[#13272B] sm:text-3xl">
                {line}
              </span>
              <RuotaMark size={20} duration={12} />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
